// 만세력 표기용 한자·십성 계산. 십성과 지장간(본기 우선)은 서버 SajuCalculator / InitialStatModel 과 같은 규칙.
export const STEM_HANJA = ['甲', '乙', '丙', '丁', '戊', '己', '庚', '辛', '壬', '癸'];
export const BRANCH_HANJA = ['子', '丑', '寅', '卯', '辰', '巳', '午', '未', '申', '酉', '戌', '亥'];
export const EL_HANJA = ['木', '火', '土', '金', '水'];
export const STEM_EL = [0, 0, 1, 1, 2, 2, 3, 3, 4, 4];
export const BRANCH_EL = [4, 2, 0, 0, 2, 1, 1, 2, 3, 3, 2, 4];
// 지장간: 본기를 첫 칸에 둔 목록 (서버 HIDDEN_STEMS 와 동일)
export const HIDDEN_STEMS = [
  [9], [5, 9, 7], [0, 2, 4], [1], [4, 1, 9], [2, 4, 6],
  [3, 5], [5, 3, 1], [6, 8, 4], [7], [4, 7, 3], [8, 0],
];
const SIPSEONG = ['비견', '겁재', '식신', '상관', '편재', '정재', '편관', '정관', '편인', '정인'];

/** 일간 기준 other 천간의 십성 */
export function sipseong(dayStem, other) {
  const rel = (STEM_EL[other] - STEM_EL[dayStem] + 5) % 5;
  const same = dayStem % 2 === other % 2;
  return SIPSEONG[rel * 2 + (same ? 0 : 1)];
}
export const polarity = (stem) => (stem % 2 === 0 ? '陽' : '陰');
export const branchPolarity = (branch) => ([0, 2, 4, 6, 8, 10].includes(branch) ? '陽' : '陰');
